/**
 * <video-player> — click-to-play. For HTML5 <video>, plays directly.
 * For <iframe> (YouTube/Vimeo) it lazy-loads the src on first play to
 * avoid loading 3rd party JS until the user actually wants to watch.
 */

class VideoPlayer extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video[data-video]');
    this.iframe = this.querySelector('iframe[data-iframe-src]');
    this.playBtn = this.querySelector('[data-play]');
    if (!this.playBtn) return;

    this.playBtn.addEventListener('click', () => this.start());
  }

  start() {
    this.setAttribute('playing', '');

    if (this.video) {
      this.video.play().catch(() => {});
      return;
    }

    if (this.iframe) {
      const src = this.iframe.dataset.iframeSrc;
      if (!src) return;
      const url = this.toEmbedUrl(src);
      this.iframe.src = url;
    }
  }

  pause() {
    this.removeAttribute('playing');
    if (this.video && !this.video.paused) {
      this.video.pause();
    }
  }

  toggle() {
    if (this.video) {
      if (this.video.paused) {
        this.start();
      } else {
        this.pause();
      }
      return;
    }
    if (this.iframe && !this.hasAttribute('playing')) {
      this.start();
    }
  }

  toEmbedUrl(url) {
    try {
      const u = new URL(url);
      if (u.hostname.includes('youtube.com') || u.hostname === 'youtu.be') {
        const id = u.hostname === 'youtu.be'
          ? u.pathname.slice(1)
          : u.searchParams.get('v') || u.pathname.split('/').pop();
        return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
      }
      if (u.hostname.includes('vimeo.com')) {
        const id = u.pathname.split('/').filter(Boolean).pop();
        return `https://player.vimeo.com/video/${id}?autoplay=1`;
      }
      return url;
    } catch {
      return url;
    }
  }
}

if (!customElements.get('video-player')) {
  customElements.define('video-player', VideoPlayer);
}
